import { numberFormat } from '../../../utils';

// eslint-disable-next-line import/prefer-default-export
export const formatProcessorTotalsValue = (total) => {
    return numberFormat(total ?? 0, 2, '.', ',');
};
